<template>
    <el-dialog
            :before-close="handleDialogClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="followRecordAddVisible"
            class="custom_form_dialog custom-form-dialog"
            title="写跟进"
            width="560px"
    >
        <div v-loading="dialogLoading" class="custom_form_body">
            <CustomFormPc
                    :relate_customer_id="Number(customer_id)"
                    v-if="formInfoList && formInfoList.length"
                    ref="crm_custom_form"
                    :field_list="formInfoList"
                    @submit-form="submitFormData"

            />
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import {customerPrivateFollowUpAdd, getFormFields} from "@/api";
    import CustomFormPc from "@/components/pComponents/CustomFormPc";

    export default {
        name: "FollowRecordAdd",
        components: {
            CustomFormPc,
        },
        props: {
            followRecordAddVisible: {
                type: Boolean,
                default: false,
            },
            customer_id: "",
        },
        data() {
            return {
                dialogLoading: false,
                btnDisabled: false,
                formInfoList: [],
            };
        },
        created() {
            this._getFromFields();
        },
        methods: {
            //表单字段获取
            _getFromFields() {
                this.dialogLoading = true;
                getFormFields({
                    field_form: "customer_follow_ups",
                }).then((res) => {
                    if (res.code === 200) {
                        this.formInfoList = res.data;
                        this.dialogLoading = false;
                    }
                });
            },
            handleClickAddQuote(url) {
            },

            loadingEnd(loading) {
                this.dialogLoading = loading;
            },
            submitFormData(customForm) {
                if (customForm) {
                    this.btnDisabled = true;
                    this.dialogLoading = true;
                    const form = {
                        customer_id: this.customer_id,
                        ...customForm,
                    };
                    customerPrivateFollowUpAdd(form)
                            .then((res) => {
                                if (res.code == 200) {
                                    this.$message.success(res.message);
                                    this.$emit("update:followRecordAddVisible", false);
                                    this.$emit("createCallback");
                                } else {
                                    this.$message.error(res.message);
                                }
                                this.btnDisabled = false;
                                this.dialogLoading = false;
                            })
                            .catch(() => {
                                this.btnDisabled = false;
                                this.dialogLoading = false;
                            });
                }
            },
            handleDialogClose() {
                this.$emit("update:followRecordAddVisible", false);
            },
            handleDialogConfirm() {
                this.$refs.crm_custom_form.handleClickPublish();
            },
        },
    };
</script>
